export function FilterButton({isActive, name, onclick, ...prop}) {
    return (
        <div {...prop}
             onClick={onclick}
             className={"filter-button " + (isActive && "box-shadow bg-white")}>
            <span className={"text-16 font-bold"}>{name}</span>
        </div>
    );
}